import React, { useState } from "react";
import { Checkbox } from "antd";

import DefaultTextbox from "../input-fields/default-textbox";

import "./styles.css";

const HorizontalCheckboxSignup = ({ options, onChange, value }) => {
  const [selected, setSelected] = useState(value || null);
  const [otherValue, setOtherValue] = useState("");

  const handleCheckboxChange = (val) => {
    const selectedValue = val[val.length - 1];

    if (selectedValue === "Other") {
      setSelected("Other");
      setOtherValue("");
      onChange("Other");
    } else {
      setSelected(selectedValue);
      setOtherValue("");
      onChange(selectedValue);
    }
  };

  const handleOtherInputChange = (e) => {
    const inputVal = e.target.value;
    setOtherValue(inputVal);
    onChange(inputVal);
  };

  return (
    <div className="flex flex-col gap-3">
      <Checkbox.Group
        value={selected === "Other" ? ["Other"] : selected ? [selected] : []}
        onChange={handleCheckboxChange}
        className="flex gap-3 horizontalCheckboxSignup font-bold"
      >
        {options.map((option) => (
          <Checkbox key={option.value} value={option.value}>
            {option.label}
          </Checkbox>
        ))}
        <Checkbox value="Other">5. Other</Checkbox>
      </Checkbox.Group>

      {selected === "Other" && (
        <DefaultTextbox
          placeholder="Please specify"
          value={otherValue}
          onChange={handleOtherInputChange}
        />
      )}
    </div>
  );
};

export default HorizontalCheckboxSignup;
